import React from 'react';
import { useRoll } from '@root/hooks';
import { appSelector, type AppSliceState } from '@root/store/slices/appSlice';
import { useActions, useTypedSelector } from '@root/store/store';
import { useImageUrl } from '@shared/components/ImageContext';
import { useTranslation } from 'react-i18next';
import styles from './RollRejectedModal.module.scss';

// The bet bounced. Nothing was charged, so the player can just try again.
const RollRejectedModal: React.FC = () => {
  const { t } = useTranslation();
  const { rollRejectedOpen } = useTypedSelector<AppSliceState>(appSelector);
  const { setRollRejectedOpen } = useActions();
  const { roll, canRoll } = useRoll();
  const { img, imgProps } = useImageUrl();

  if (!rollRejectedOpen) return null;

  const close = () => setRollRejectedOpen(false);

  const retry = () => {
    setRollRejectedOpen(false);
    void roll();
  };

  return (
    <div className={styles.scrim}>
      <div
        className={styles.dialog}
        style={
          { '--panel-skin': `url(${img('PopupFrame')})` } as React.CSSProperties
        }
      >
        <div className={styles.head}>
          <h2 className={styles.title}>{t('Unable to place roll')}</h2>
          <button
            type="button"
            className={styles.close}
            aria-label={t('Close')}
            onClick={close}
          >
            <img {...imgProps('Icon_Close')} alt="" />
          </button>
        </div>

        <p className={styles.body}>
          {t(
            'No charge was made. Your board and position are unchanged. Please try again.'
          )}
        </p>

        <button
          type="button"
          className={styles.retry}
          style={
            {
              '--button-skin': `url(${img('ButtonSkin_Primary')})`,
            } as React.CSSProperties
          }
          disabled={!canRoll}
          onClick={retry}
        >
          {t('RETRY ROLL')}
        </button>
      </div>
    </div>
  );
};

export default RollRejectedModal;
